import React, { useState, useContext, useEffect } from 'react';
import { IconButton, Menu, MenuItem, Avatar, Typography, Box, Divider, Tooltip, Stack, Button } from '@mui/material';
import { Context } from '../../App';
import { Navigate, useNavigate } from 'react-router-dom';
import { Logout } from '@mui/icons-material';

const AccountMenu = () => {
    const navigate = useNavigate();
    const { isConnected, setIsConnected } = useContext(Context);
    const user = JSON.parse(sessionStorage.getItem('user'));
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleOpen = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);

    const handleDeconnect = () => {
        handleClose();
        // Clear user data and local storage
        sessionStorage.clear();
        setIsConnected(false);
    }

    useEffect(() => {
        if(!user) {
            sessionStorage.clear();
            setIsConnected(false);
        }
    }, [user]);

    return (
        <>
        <Tooltip title="Mon compte">
            <IconButton
            onClick={handleOpen}
            onMouseEnter={handleOpen}
            size="large"
            edge="end"
            aria-controls={open ? 'account-menu' : undefined}
            aria-haspopup="true"
            >
            <Avatar sx={{ width: 42, height: 42, bgcolor: 'primary.soft', color:'grey', fontSize: 16, fontWeight:'bold' }}>
                {(user.nom.charAt(0) + user.prenom.charAt(0)).toUpperCase()}
            </Avatar>
            </IconButton>
        </Tooltip>

        <Menu
            id="account-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            onMouseLeave={handleClose}
            slotProps={{ list: { onMouseLeave: handleClose} }}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
            {/* En-tête utilisateur */}
            <Stack direction="row" alignItems="center" spacing={1} px={1} pb={1}>
                <Avatar sx={{ width: 42, height: 42, bgcolor: 'primary.soft', color:'grey', fontSize: 16, fontWeight:'bold' }}>
                    {(user.nom.charAt(0) + user.prenom.charAt(0)).toUpperCase()}
                </Avatar>
                <Box sx={{minWidth: 200}}>
                    <Typography variant="body1" color="black" fontSize={14} fontWeight="bold">{user.prenom+' '+user.nom}</Typography>
                    <Typography variant="body1" color="black" fontSize={12}>{user.mail}</Typography>
                </Box>
            </Stack>

            <Divider sx={{ margin: 0 }} />

            <Box sx={{ pt: 1, pr:1, display: 'flex', justifyContent:'end' }}>
                <Button variant='outlined' startIcon={<Logout />} onClick={handleDeconnect} 
                sx={{fontSize:14, fontFamily:'Inter', borderWidth:1, borderRadius:1}}>Déconnexion</Button>
            </Box>
        </Menu>
        </>
    );
};

export default AccountMenu;
